export enum PartitionOPEEnum {
  GetPartitionDetail = 'getPartitionDetail',
  GetPartitionHierarchy = 'getPartitionHierarchy',
  PutPartition = 'putPartition',
  DelPartition = 'delPartition',
  UpdateParentPartition = 'updateParentPartition'
}
